module.exports = __webpack_public_path__ + "media/images/navbar/logo-400b2d1c60bff549bf8ef02ccf195cf5.svg";